import StatusCard from './StatusCard.vue';
import FormConsolidado from './FormConsolidado.vue';
import FormRascunho from './FormRascunho.vue';
import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import { PlanoService } from '../../services/PlanoService';
import { DotacaoService } from '../../services/DotacaoService';

export default {
  data: () => ({
    breadcrumbs: [
      {
        text: 'Página Inicial',
        disabled: false,
        href: '/',
      },
      {
        text: 'Planos de Aquisição',
        disabled: false
      },
      {
        text: 'Montagem do Plano de Aquisição',
        disabled: true
      }
    ],
    tabs: ["Versão Consolidada", "Rascunho", "Histórico de Versões"],
    tab: 0,
    showConsolidada: false,
    headers: [
      { text: 'ID:', align: 'start', value: 'id' },
      { text: 'Plano', align: 'start', value: 'plano_aquisicao.nome' },
      { text: 'Status', align: 'start', value: 'tipo_versao' },
      { text: 'Data', align: 'start', value: 'created_at' },
    ],
    historico: [],
    itemSelected: [],
    formRascunho: {
      totalItensAquisicao: 0,
      nome: "",
      descricao: "",
      documento_sei: "",
      validade: "",
      valor: 0,
      dotacoes: [{ 
        exercicioSelected: null,
        exerciciosOptions: [],
        unidadesOptions: [],
        unidadeSelected: null,
        dotacoesOptions: [],
        dotacao: "", 
        valor: "" 
      }],
      itensAquisicao: [
        { tipo_item: "", numero_rp: "", numero_item_rp: "", codigo_item: "", descricao: "", valor_unitario: "", valor_total: "", quantidade: "" }
      ],
    },
    formConsolidado: {
      totalItensAquisicao: 0,
      nome: "",
      descricao: "",
      documento_sei: "",
      elaborador: "",
      validade: "",
      valor: 0,
      dotacoes: [{ dotacao: "", valor: "" }],
      itensAquisicao: [
        { tipo_item: "", numero_rp: "", numero_item_rp: "", codigo_item: "", descricao: "", valor_unitario: "", valor_total: "", quantidade: "" }
      ],
    },
    dotacoes: [],
    tipoItens: [
      {
        text: "Selecione",
        value: "",
      },
      {
        text: "RP",
        value: "RP"
      },
      {
        text: "Itens de Licitação",
        value: "ITENS_LICITACAO"
      }
    ]
  }),
  components: {
    StatusCard,
    FormConsolidado,
    FormRascunho,
    Breadcrumb
  },
  computed: {
    filteredTabs() {
      return this.tabs.filter(
        (tab) => tab !== "Versão Consolidada" || this.showConsolidada
      );
    },
  },
  created() {
    this.carregarPlanoAquisicao(this.$route.params.id);
    this.listarDotacoesSelect();
    this.carregaHistorico();
  },
  methods: {
    copyToRascunho(formConsolidado) {
      this.tab = 1;
      this.formRascunho = JSON.parse(JSON.stringify(formConsolidado));
    },
    async salvarEConsolidar() {
      try {
        await this.salvarRascunho();  
        await this.consolidarPlano();
      } catch (error) {
        console.error('Erro ao salvar e consolidar:', error);
      }
    },
    async salvarRascunho() {
      const formData = new FormData();

      if (this.$route.params.id) {
        formData.append("plano_aquisicao_id", this.$route.params.id);
      }

      formData.append("nome", this.formRascunho.nome);
      formData.append("descricao", this.formRascunho.descricao);
      formData.append("documento_sei", this.formRascunho.documento_sei);
      formData.append("validade", this.formRascunho.valor == this.formRascunho.totalItensAquisicao);
      formData.append("valor", this.formRascunho.valor);

      this.formRascunho.dotacoes.forEach((dotacao, index) => {
        formData.append(`dotacoes[${index}][id]`, dotacao.dotacao);
        formData.append(`dotacoes[${index}][valor]`, dotacao.valor);
      });

      this.formRascunho.itensAquisicao.forEach((item, index) => {
        formData.append(`itensAquisicao[${index}][tipo_item]`, item.tipo_item);
        formData.append(`itensAquisicao[${index}][numero_rp]`, item.numero_rp);
        formData.append(`itensAquisicao[${index}][numero_item_rp]`, item.numero_item_rp);
        formData.append(`itensAquisicao[${index}][codigo_item]`, item.codigo_item);
        formData.append(`itensAquisicao[${index}][descricao]`, item.descricao);
        formData.append(`itensAquisicao[${index}][valor_unitario]`, item.valor_unitario);
        formData.append(`itensAquisicao[${index}][valor_total]`, item.valor_total);
        formData.append(`itensAquisicao[${index}][quantidade]`, item.quantidade);
      });

      const response = await PlanoService.sketch(formData);
    
      if (response && !this.$route.params.id) {
        this.carregaHistorico();
        this.$router.push(`/montar-plano-aquisicao/${response.data.id}`);
      }
    },
    async carregarPlanoAquisicao(id) {
      if (!this.$route.params.id) {
        return;
      }
      try {
        const response = await PlanoService.show(id);

        if (response) {
          const data = response.data;

          this.formRascunho.nome = data.rascunho.nome || "";
          this.formRascunho.descricao = data.rascunho.descricao || "";
          this.formRascunho.documento_sei = data.rascunho.documento_sei || "";
          this.formRascunho.validade = data.rascunho.validade || "";
          this.formRascunho.valor = data.rascunho.valor || 0;

          if (data.dotacoes_rascunho && data.dotacoes_rascunho.length > 0) {
            this.formRascunho.dotacoes = data.dotacoes_rascunho.map(dotacao => ({
              exercicioSelected: null,
              exerciciosOptions: [],
              unidadesOptions: [],
              unidadeSelected: null,
              dotacoesOptions: [],
              dotacao: dotacao.dotacao_id || "",
              valor: dotacao.valor || 0,
              carregado: true
            }));
          } else {
            this.formRascunho.dotacoes = [{ 
              exercicioSelected: null,
              exerciciosOptions: [],
              unidadesOptions: [],
              unidadeSelected: null,
              dotacoesOptions: [],
              dotacao: "", 
              valor: 0 
            }];
          }

          if (data.itens_rascunho && data.itens_rascunho.length > 0) {
            this.formRascunho.itensAquisicao = data.itens_rascunho.map(item => ({
              tipo_item: item.tipo_item || "",
              numero_rp: item.numero_rp || "",
              numero_item_rp: item.numero_item_rp || "",
              codigo_item: item.codigo_item || "",
              descricao: item.descricao || "",
              valor_unitario: item.valor_unitario || 0,
              valor_total: item.valor_total || 0,
              quantidade: item.quantidade || 0
            }));
          } else {
            this.formRascunho.itensAquisicao = [{
              tipo_item: "",
              numero_rp: "",
              numero_item_rp: "",
              codigo_item: "",
              descricao: "",
              valor_unitario: 0,
              valor_total: 0,
              quantidade: 0
            }];
          }

          if (data.consolidado) {
            this.formConsolidado.nome = data.consolidado.nome || "";
            this.formConsolidado.descricao = data.consolidado.descricao || "";
            this.formConsolidado.documento_sei = data.consolidado.documento_sei || "";
            this.formConsolidado.elaborador = data.consolidado.elaborador || "";
            this.formConsolidado.validade = data.consolidado.validade || "";
            this.formConsolidado.valor = data.consolidado.valor || 0;

            if (data.dotacoes_consolidado && data.dotacoes_consolidado.length > 0) {
              this.formConsolidado.dotacoes = data.dotacoes_consolidado.map(dotacao => ({
                dotacao: dotacao.dotacao_id || "",
                valor: dotacao.valor || 0
              }));
            } else {
              this.formRascunho.dotacoes = [{ dotacao: "", valor: 0 }];
            }

            if (data.itens_consolidado && data.itens_consolidado.length > 0) {
              this.formConsolidado.itensAquisicao = data.itens_consolidado.map(item => ({
                tipo_item: item.tipo_item || "",
                numero_rp: item.numero_rp || "",
                numero_item_rp: item.numero_item_rp || "",
                codigo_item: item.codigo_item || "",
                descricao: item.descricao || "",
                valor_unitario: item.valor_unitario || 0,
                valor_total: item.valor_total || 0,
                quantidade: item.quantidade || 0
              }));
            } else {
              this.formConsolidado.itensAquisicao = [{
                tipo_item: "",
                numero_rp: "",
                numero_item_rp: "",
                codigo_item: "",
                descricao: "",
                valor_unitario: 0,
                valor_total: 0,
                quantidade: 0
              }];
            }

            this.showConsolidada = true;
            this.tab = 0;
          }

        } else {
          console.error('Não foi possível carregar os dados do Plano de Aquisição.');
        }
      } catch (error) {
        console.error('Ocorreu um erro ao carregar os dados do Plano de Aquisição:', error);
      }
    },
    async carregaHistorico() {
      try {

        if (!this.$route.params.id) {
          return;
        }
        const formData = new FormData();
        formData.append("plano_aquisicao_id", this.$route.params.id);
        const response = await PlanoService.historic(formData);

        if (response && !response.error) {
          this.historico = response.data;
        } else {
          console.error('Erro ao buscar histórico.');
        }
      } catch (error) {
        console.error('Ocorreu um erro durante busca do histórico:', error);
      }
    },
    async consolidarPlano() {
      try {

        const formData = new FormData();
        formData.append("plano_aquisicao_id", this.$route.params.id);
        const response = await PlanoService.consolidate(formData);
        if (response && !response.error) {
          this.carregarPlanoAquisicao(this.$route.params.id);
          this.showConsolidada = true;
          this.tab = 0;
          this.carregaHistorico();
        } else {
          console.error('Erro ao consolidar o plano de aquisição.');
        }
      } catch (error) {
        console.error('Ocorreu um erro durante a consolidação do plano de aquisição:', error);
      }
    },
    async listarDotacoesSelect() {
      try {
        const response = await DotacaoService.select();
        if (response) {
          this.dotacoes = response.data.map((el) => {
            return {
              text: `Unidade: ${el.unidade_executora.codigo_unidade} - R$ ${el.valor}`,
              value: el.id,
            };
          });
          this.dotacoes?.unshift({
            text: "Selecione",
            value: "",
          });

        } else {
          console.error('Não foi possível obter as dotações.');
        }
      } catch (error) {
        console.error('Ocorreu um erro ao listar as dotações:', error);
      }
    },
    addDotacao() {
      this.formRascunho.dotacoes.push({
        exercicioSelected: null,
        exerciciosOptions: [],
        unidadesOptions: [],
        unidadeSelected: null,
        dotacoesOptions: [],
        dotacao: null,
        valor: ''
      });
    },
    removeDotacao(index) {
      if (this.formRascunho.dotacoes.length > 1) {
        this.formRascunho.dotacoes.splice(index, 1);
      } 
    },
    addItem() {
      this.formRascunho.itensAquisicao.push({
        tipo_item: "",
        numero_rp: "",
        numero_item_rp: "",
        codigo_item: "",
        descricao: "",
        valor_unitario: 0,
        valor_total: 0,
        quantidade: 0,
      });
    },
    removeItem(index) {
      if (this.formRascunho.itensAquisicao.length > 1) {
        this.formRascunho.itensAquisicao.splice(index, 1);
      }
    },
    limparFormulario() {
      this.formRascunho = {
        totalItensAquisicao: 0,
        nome: "",
        descricao: "",
        documento_sei: "",
        validade: "",
        valor: 0,
        dotacoes: [{ 
          exercicioSelected: null,
          exerciciosOptions: [],
          unidadesOptions: [],
          unidadeSelected: null,
          dotacoesOptions: [],
          dotacao: "", 
          valor: "" 
        }],
        itensAquisicao: [
          { tipo_item: "", numero_rp: "", numero_item_rp: "", codigo_item: "", descricao: "", valor_unitario: "", valor_total: "", quantidade: "" }
        ],
      };
      
      if (this.$route.params.id) {
        this.$router.push('/montar-plano-aquisicao').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
  },
};